import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Lock } from 'lucide';
import { NbIcon } from '../../icon/icon';

/**
 * `<nb-internal-stripe>` — the superbruker "internal tool" marker
 * (Mockup `web.css .intstripe`).
 *
 * A 32px full-width sand band (2026-09 admin prototype) with a leading `Lock`
 * icon and a projected message, rendered in uppercase by CSS (the DOM text is
 * whatever the app projects — e2e specs pin it). Marks a surface as an internal/admin-only
 * tool. Exposed to assistive technology as `role="note"`; the icon is
 * decorative (the text carries the meaning, so the status is never
 * colour-only).
 *
 * @example
 * <nb-internal-stripe>Internt verktoy — kun for superbrukere</nb-internal-stripe>
 */
@Component({
  selector: 'nb-internal-stripe',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NbIcon],
  host: {
    role: 'note',
  },
  template: `<nb-icon [icon]="Lock" />
    <ng-content />`,
  styleUrl: './internal-stripe.css',
})
export class NbInternalStripe {
  protected readonly Lock = Lock;
}
